import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, a = /* @__PURE__ */ o("path", { d: "M15.53 7.53A.75.75 0 0 1 14.25 7V3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .53 1.28l-1.12 1.122.014.012a9.75 9.75 0 0 1-6.082 17.08.75.75 0 0 1-.053-1.499 8.25 8.25 0 0 0 5.147-14.452.75.75 0 0 1-.083-.085L15.53 7.53Zm-5.414-3.562a.75.75 0 1 0-.342-1.46 9.75 9.75 0 0 0-4.183 16.84L4.47 20.47A.75.75 0 0 0 5 21.75h4a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-1.28-.53l-1.815 1.815a8.25 8.25 0 0 1 3.461-14.317Z" }, null, -1), c = [
  a
];
function r(s, l) {
  return e(), t("svg", n, [...c]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
